<!--
  Doré = signal premium, jamais l'orange des avertissements : l'utilisateur ne
  doit pas confondre une invitation avec une alerte de son jardin.

  L'encart ANNONCE ce que Premium débloque à cet endroit précis. Un encart qui
  se contente de dire « Découvrir Premium » demande de la curiosité ; celui-ci
  répond à la question avant qu'elle soit posée.
-->
@if (premiumService.premiumEnabled() && line) {
<!-- Une ligne, une cible : l'accroche se lit d'un regard, après les gestes. Le texte est écrit court
     pour tenir dans les six langues ; une ellipse le coupe proprement s'il déborde (texte agrandi). -->
<button type="button" (click)="onClick()" data-test="premium-line"
  class="flex min-h-target w-full items-center gap-2 rounded-field border border-vw-premium-line bg-gradient-to-r from-vw-premium-bg to-vw-premium-bg-deep px-3 py-1.5 text-left text-body-s font-medium text-vw-premium-ink">
  <vw-star-icon class="h-4 w-4 shrink-0 text-vw-premium-accent" aria-hidden="true"></vw-star-icon>
  <span class="min-w-0 flex-1 truncate">{{ message }}</span>
  <vw-chevron-right-icon class="block h-5 w-5 shrink-0 opacity-70 [&>svg]:h-full [&>svg]:w-full" aria-hidden="true"></vw-chevron-right-icon>
</button>
} @else if (premiumService.premiumEnabled()) {
<button
  type="button"
  (click)="onClick()"
  class="flex w-full items-start gap-3 rounded-card border border-vw-premium-line bg-gradient-to-r from-vw-premium-bg to-vw-premium-bg-deep text-left"
  [ngClass]="compact ? 'px-3 py-2.5' : 'px-4 py-3'"
>
  <span
    class="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-pill bg-vw-premium-accent text-vw-on-color"
  >
    <vw-lock-icon class="h-4 w-4" />
  </span>

  <span class="min-w-0 flex-1">
    <span
      class="mb-0.5 inline-block rounded-pill border border-vw-premium-line bg-vw-surface px-1.5 text-caption font-bold uppercase tracking-wide text-vw-premium-ink"
    >
      {{ 'premium.teaser.badge' | translate }}
    </span>

    <!-- Deux lignes plutôt qu'une troncature : les traductions allemandes et
         néerlandaises sont nettement plus longues qu'en français, et un encart
         coupé au milieu d'un mot ne vend rien. -->
    <span class="block line-clamp-2 text-body-s font-semibold text-vw-premium-ink">{{
      message
    }}</span>

    @if (detail) {
    <span class="mt-0.5 block text-caption font-normal text-vw-premium-ink">{{
      detail
    }}</span>
    } @else {
    <span class="block text-caption font-normal text-vw-premium-ink">{{ ctaLabel | translate }}</span>
    }
  </span>

  <svg
    class="h-5 w-5 shrink-0 self-center text-vw-premium-ink"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M9 6l6 6-6 6"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</button>
}
